var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "live-shopping-details" },
    [
      _c("div", { staticClass: "h3 live-shopping-item-name" }, [
        _c(
          "a",
          { attrs: { href: _vm._f("itemURL")(_vm.liveShoppingData.item) } },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm._f("itemName")(_vm.liveShoppingData.item)) +
                "\n        "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm._t("after-item-name"),
      _vm._v(" "),
      _vm.displaySettings.showTimer || _vm.displaySettings.showStock
        ? _c(
            "div",
            { staticClass: "live-shopping-countdown" },
            [
              _c("hr", { staticClass: "live-shopping-countdown-separator" }),
              _vm._v(" "),
              _vm.displaySettings.showTimer
                ? _c(
                    "div",
                    { staticClass: "live-shopping-countdown-heading" },
                    [
                      _vm.hasStarted
                        ? _c("div", [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.liveShoppingOfferEndsIn"
                                  )
                                ) +
                                "\n            "
                            )
                          ])
                        : _c("div", [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.liveShoppingOfferBeginsIn"
                                  )
                                ) +
                                "\n            "
                            )
                          ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.displaySettings.showTimer && !!_vm.duration
                ? _c(
                    "div",
                    { staticClass: "live-shopping-countdown-thread-container" },
                    [
                      _vm.duration.days > 0
                        ? _c(
                            "div",
                            { staticClass: "live-shopping-countdown-thread" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "live-shopping-countdown-thread-number"
                                },
                                [_vm._v(_vm._s(_vm.duration.days))]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "small" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.liveShoppingDays"
                                    )
                                  )
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "live-shopping-countdown-thread" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "live-shopping-countdown-thread-number"
                            },
                            [_vm._v(_vm._s(_vm.duration.hours))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "small" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.liveShoppingHours"
                                )
                              )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "live-shopping-countdown-thread" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "live-shopping-countdown-thread-number"
                            },
                            [_vm._v(_vm._s(_vm.duration.minutes))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "small" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.liveShoppingMinutes"
                                )
                              )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.duration.days <= 0
                        ? _c(
                            "div",
                            { staticClass: "live-shopping-countdown-thread" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "live-shopping-countdown-thread-number"
                                },
                                [_vm._v(_vm._s(_vm.duration.seconds))]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "small" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.liveShoppingSeconds"
                                    )
                                  )
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasStarted && !_vm.hasClosed
                ? [
                    _vm.displaySettings.showTimer &&
                    _vm.displaySettings.showTimerProgress
                      ? _c("div", { staticClass: "live-shopping-progress" }, [
                          _c("div", { staticClass: "progress" }, [
                            _c("div", {
                              staticClass: "progress-bar",
                              class:
                                "progress-" +
                                Math.round(_vm.timePercentage / 10) * 10,
                              style: "width:" + _vm.timePercentage + "%",
                              attrs: {
                                role: "progressbar",
                                "aria-valuenow": "25",
                                "aria-valuemin": "0",
                                "aria-valuemax": "100"
                              }
                            })
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.displaySettings.showStock
                      ? _c("div", { staticClass: "live-shopping-progress" }, [
                          _c(
                            "div",
                            { staticClass: "live-shopping-progress-heading" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.liveShoppingRemainingStock",
                                      {
                                        quantityRemaining:
                                          _vm.itemQuantityRemaining,
                                        quantityMax:
                                          _vm.liveShoppingData.liveShopping
                                            .quantityMax
                                      }
                                    )
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm.displaySettings.showStockProgress
                            ? _c("div", { staticClass: "progress" }, [
                                _c("div", {
                                  staticClass: "progress-bar",
                                  class:
                                    "progress-" +
                                    Math.round(
                                      _vm.quantitySoldPercentage / 10
                                    ) *
                                      10,
                                  style:
                                    "width:" + _vm.quantitySoldPercentage + "%",
                                  attrs: {
                                    role: "progressbar",
                                    "aria-valuenow": "25",
                                    "aria-valuemin": "0",
                                    "aria-valuemax": "100"
                                  }
                                })
                              ])
                            : _vm._e()
                        ])
                      : _vm._e()
                  ]
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasStarted && !_vm.hasClosed
        ? _c("div", { staticClass: "live-shopping-prices bg-danger" }, [
            _c("div", { staticClass: "live-shopping-prices-inner" }, [
              !isNaN(_vm.itemPriceRebatePercentage) &&
              _vm.itemPriceRebatePercentage > 0
                ? _c("div", { staticClass: "live-shopping-prices-rebate" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("Ceres::Template.liveShoppingRebate", {
                          rebate: _vm.itemPriceRebatePercentage
                        })
                      )
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "live-shopping-prices-container" }, [
                _c("div", { staticClass: "live-shopping-price" }, [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.prices.price.unitPrice.formatted) + " *")
                  ])
                ]),
                _vm._v(" "),
                _vm.isCrossPriceVisible
                  ? _c("span", [
                      _vm.prices.isRrpDefaultPrice
                        ? _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.oldPriceBefore) }
                          })
                        : _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.oldPriceRrp) }
                          })
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "live-shopping-prices-additional-info" },
              [
                _vm.isCrossPriceVisible &&
                _vm.liveShoppingData.item.prices.default.lowestPrice.value
                  ? _c("div", { staticClass: "live-shopping-lowest-price" }, [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$translate(
                              "Ceres::Template.singleItemLowestPrice",
                              {
                                price:
                                  _vm.liveShoppingData.item.prices.default
                                    .lowestPrice.formatted
                              }
                            )
                          )
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !(
                  _vm.liveShoppingData.item.unit.unitOfMeasurement === "C62" &&
                  _vm.liveShoppingData.item.unit.content === 1
                )
                  ? _c("div", { staticClass: "live-shopping-unit-price" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.liveShoppingData.item.unit.content))
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.liveShoppingData.item.unit.names.name)
                        )
                      ]),
                      _vm._v(" "),
                      _vm.liveShoppingData.item.variation.mayShowUnitPrice
                        ? _c("span", [
                            _vm._v("| " + _vm._s(_vm.prices.price.basePrice))
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(
                  "\n\n            " +
                    _vm._s(
                      _vm.$translate("Ceres::Template.liveShoppingFootnote")
                    ) +
                    " "
                ),
                _vm.showNetPrices
                  ? [
                      _vm._v(
                        _vm._s(_vm.$translate("Ceres::Template.itemExclVAT"))
                      )
                    ]
                  : [
                      _vm._v(
                        _vm._s(_vm.$translate("Ceres::Template.itemInclVAT"))
                      )
                    ],
                _vm._v(
                  " " +
                    _vm._s(_vm.$translate("Ceres::Template.itemExclusive")) +
                    "\n            "
                ),
                _vm.$ceres.config.global.shippingCostsCategoryId > 0
                  ? _c(
                      "a",
                      {
                        attrs: {
                          "data-toggle": "modal",
                          href: "#shippingscosts",
                          title: _vm.$translate(
                            "Ceres::Template.itemShippingCosts"
                          )
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.itemShippingCosts")
                          )
                        )
                      ]
                    )
                  : _c(
                      "a",
                      {
                        attrs: {
                          title: _vm.$translate(
                            "Ceres::Template.itemShippingCosts"
                          )
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.itemShippingCosts")
                          )
                        )
                      ]
                    )
              ],
              2
            )
          ])
        : _c("div", { staticClass: "thumb-content" }, [
            _c("div", [
              _c("div", { staticClass: "prices" }, [
                _c("div", { staticClass: "price-view-port" }, [
                  _vm.isCrossPriceVisible
                    ? _c("del", { staticClass: "crossprice" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm._f("itemCrossPrice")(
                                _vm.prices.rrp.price.formatted
                              )
                            ) +
                            "\n                    "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "price" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.prices.price.price.formatted) +
                      " *\n                "
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.isCrossPriceVisible &&
              _vm.liveShoppingData.item.prices.default.lowestPrice.value
                ? _c("div", { staticClass: "category-lowest-price small" }, [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$translate(
                            "Ceres::Template.singleItemLowestPrice",
                            {
                              price:
                                _vm.liveShoppingData.item.prices.default
                                  .lowestPrice.formatted
                            }
                          )
                        )
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              !(
                _vm.liveShoppingData.item.unit.unitOfMeasurement === "C62" &&
                _vm.liveShoppingData.item.unit.content === 1
              )
                ? _c("div", { staticClass: "category-unit-price small" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.liveShoppingData.item.unit.content))
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.liveShoppingData.item.unit.names.name))
                    ]),
                    _vm._v(" "),
                    _vm.liveShoppingData.item.variation.mayShowUnitPrice
                      ? _c("span", [
                          _vm._v("| " + _vm._s(_vm.prices.price.basePrice))
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "vat small text-muted" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$translate("Ceres::Template.liveShoppingFootnote")
                      ) +
                      " "
                  ),
                  _vm.showNetPrices
                    ? [
                        _vm._v(
                          _vm._s(_vm.$translate("Ceres::Template.itemExclVAT"))
                        )
                      ]
                    : [
                        _vm._v(
                          _vm._s(_vm.$translate("Ceres::Template.itemInclVAT"))
                        )
                      ],
                  _vm._v(
                    " " +
                      _vm._s(_vm.$translate("Ceres::Template.itemExclusive")) +
                      "\n                "
                  ),
                  _vm.$ceres.config.global.shippingCostsCategoryId > 0
                    ? _c(
                        "a",
                        {
                          attrs: {
                            "data-toggle": "modal",
                            href: "#shippingscosts",
                            title: _vm.$translate(
                              "Ceres::Template.itemShippingCosts"
                            )
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.itemShippingCosts"
                              )
                            )
                          )
                        ]
                      )
                    : _c(
                        "a",
                        {
                          attrs: {
                            title: _vm.$translate(
                              "Ceres::Template.itemShippingCosts"
                            )
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.itemShippingCosts"
                              )
                            )
                          )
                        ]
                      )
                ],
                2
              )
            ])
          ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }